import {
    Button, Form, Input, Space,
} from 'antd';
import { useEffect, useState } from 'react';
import { BsPlusCircle, BsTrash } from 'react-icons/bs';
import { pay } from '../../api/payments';
import { OctopusPaginatorQuery } from '../../types/paginator';
import WorkspaceInputSearch from '../WorkspaceInputSearch';
import PayButton from './PaymentButton';
import UploadInput from './UploadInput';

interface PaymentezReceivablesProps {
    setPaymentsPagination: React.Dispatch<React.SetStateAction<OctopusPaginatorQuery>>
}

const PaymentezReceivables = ({ setPaymentsPagination }: PaymentezReceivablesProps) => {
    const [form] = Form.useForm();
    const [business, setBusiness] = useState([]);

    useEffect(() => {
        form.setFieldsValue({ business });
    }, [business, form]);

    const addPayment = async (paymentId: string) => {
        const values = form.getFieldsValue().business[paymentId];
        await pay({
            workspaceUniqueID: values.id,
            amount: parseFloat(values.amount),
        });
        setPaymentsPagination((paymentsPagination) => ({ ...paymentsPagination }));
    };

    const workspaceSelectedData = ({ id, field, name }: { id: string, field: any, name: string }) => {
        const { business } = form.getFieldsValue();

        business[field.key] = {
            name,
            id,
        };

        form.setFieldsValue({ business });
    };

    const handleSubmit = (values: any) => {
        console.log(values);
    };

    return (
        <div style={{ margin: '0 25px' }}>
            <Form size="large" form={form} onFinish={handleSubmit}>
                <Form.List name="business">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map((field) => (
                                <div key={field.key}>
                                    <Space align="baseline">
                                        <Form.Item
                                            {...field}
                                            label="Workspace Id"
                                            name={[field.name, 'id']}
                                            rules={[{ required: true, message: 'Missing Workspace Id' }]}
                                        >
                                            <Input placeholder="WS123" />
                                        </Form.Item>
                                        <Form.Item
                                            {...field}
                                            label="Workspace Name"
                                            name={[field.name, 'name']}
                                            rules={[{ required: true, message: 'Missing name' }]}
                                        >
                                            <WorkspaceInputSearch
                                                placeholder="Picker Workspace"
                                                style={{ width: 200 }}
                                                field={field}
                                                workspaceSelectedData={workspaceSelectedData}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            {...field}
                                            label="Amount"
                                            name={[field.name, 'amount']}
                                            rules={[{ required: true, message: 'Missing amount' }]}
                                        >
                                            <Input type="number" placeholder="10.0" />
                                        </Form.Item>
                                        <Button danger onClick={() => remove(field.name)}>
                                            <span className="anticon">
                                                <BsTrash size={17} />
                                            </span>
                                        </Button>
                                        <PayButton
                                            form={form}
                                            field={field}
                                            addPayment={addPayment}
                                        />
                                    </Space>
                                </div>
                            ))}

                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    block
                                    icon={<span className="anticon"><BsPlusCircle /></span>}
                                >
                                    Add workspace
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form>
            {business.length === 0 && (
                <UploadInput handleFileUpload={setBusiness} />
            )}
        </div>
    );
};

export default PaymentezReceivables;
